import { useContext, useEffect, useState, type FC } from "react";
import { AiOutlineDollar } from "react-icons/ai";
import { BsBuilding, BsCash, BsGear, BsShop, BsStar } from "react-icons/bs";
import { FiUser } from "react-icons/fi";
import { GoPeople } from "react-icons/go";
import { GrLike, GrMoney } from "react-icons/gr";
import { HiOutlineShoppingBag, HiOutlineTruck } from "react-icons/hi2";
import { LuFolderKey } from "react-icons/lu";
import { MdOutlineInventory } from "react-icons/md";
import { PiFlagBanner, PiWarehouse } from "react-icons/pi";
import {
  TbCashOff,
  TbCategory2,
  TbCodeAsterisk,
  TbLayoutDashboard,
  TbMoneybag,
  TbShoppingBagExclamation,
  TbTagStarred,
} from "react-icons/tb";
import { TfiReload } from "react-icons/tfi";
import { TiTags } from "react-icons/ti";
import { useNavigate, useParams } from "react-router-dom";
import { Nav, Sidenav } from "rsuite";
import { ExpandedContext } from "../contexts/Expanded";
import { LoadingContext } from "../contexts/LoadingContext";
import { countPendingMerchants } from "../services/sales/MerchantApi";
import { PiCashRegisterLight } from "react-icons/pi";
import { countPendingSales } from "../services/sales/SalesApi";
import {
  IoStorefront,
  IoStorefrontOutline,
  IoTvOutline,
} from "react-icons/io5";
import { countPendingProducts } from "../services/inventory/ProductApi";
import { countPendingWithdrawals } from "../services/sales/WithdrawalApi";
import { GiProgression } from "react-icons/gi";
interface CustomSidebarProps {}
const CustomSidebar: FC<CustomSidebarProps> = ({}) => {
  const [activeKey, setActiveKey] = useState("/");
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const { isExpanded, setIsExpanded } = useContext(ExpandedContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [countMerchant, setCountMerchant] = useState(0);
  const [countProduct, setCountProduct] = useState(0);
  const [countSales, setCountSales] = useState(0);
  const [countWitdrawal, setCountWitdrawal] = useState(0);
  const nav = useNavigate();
  let params = useParams();
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (!mounted) return;
    const url = window.location.pathname;

    setActiveKey(url);
    switch (url) {
      case "/":
        break;
      case "/tag":
      case "/brand":
      case "/top-brand":
      case "/popular-product":
      case "/master-product":
      case "/product-recommendation":
      case "/product-category":
      case "/product-attribute":
      case "/price-category":
      case "/warehouse":
      case "/product":
      case "/product-pending":
      case "/stock-movement":
        setOpenKeys(["inventory"]);
        break;
      case "/sales":
      case "/merchant":
      case "/withdrawal":
      case "/banner":
      case "/promotion":
        setOpenKeys(["order"]);
        break;
      case "/admin":
      case "/role":
      case "/setting":
      case "/merchant-type":
        setOpenKeys(["system"]);
        break;
      default:
        if (params.hasOwnProperty("withdrawalId")) {
          setOpenKeys(["order"]);
          setActiveKey("/withdrawal");
        }
        if (params.hasOwnProperty("salesId")) {
          setOpenKeys(["order"]);
          setActiveKey("/sales");
        }
        if (params.hasOwnProperty("promotionId")) {
          setOpenKeys(["order"]);
          setActiveKey("/promotion");
        }
        if (params.hasOwnProperty("merchantId")) {
          setOpenKeys(["sales"]);
          setActiveKey("/merchant");
        }
        if (params.hasOwnProperty("productId")) {
          setOpenKeys(["inventory"]);
          setActiveKey("/product");
        }
        if (params.hasOwnProperty("masterProductId")) {
          setOpenKeys(["inventory"]);
          setActiveKey("/master-product");
        }
        break;
    }
    countPendingSales()
      .then((v) => v.json())
      .then((resp) => {
        setCountSales(resp.data);
      });
    countPendingWithdrawals()
      .then((v) => v.json())
      .then((resp) => {
        setCountWitdrawal(resp.data);
      });
    countPendingMerchants()
      .then((v) => v.json())
      .then((resp) => {
        setCountMerchant(resp.data);
      });
    countPendingProducts()
      .then((v) => v.json())
      .then((resp) => {
        setCountProduct(resp.data);
      })
      .catch((err) => console.log(err));
  }, [mounted]);

  return (
    <Sidenav
      className=""
      expanded={isExpanded}
      openKeys={openKeys}
      onOpenChange={(val) => {
        setOpenKeys(val as string[]);
      }}
    >
      <Sidenav.Body>
        <Nav>
          <Nav.Item
            eventKey="/"
            active={activeKey === "/"}
            onClick={() => nav("/")}
            icon={
              <TbLayoutDashboard className="rs-sidenav-item-icon rs-icon" />
            }
          >
            Dashboard
          </Nav.Item>
          <Nav.Item
            eventKey="company"
            active={activeKey === "/company"}
            icon={
              <BsBuilding className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
            }
            onClick={() => nav("/company")}
          >
            Company
          </Nav.Item>
          {/* <Nav.Item
            eventKey="distributor"
            active={activeKey === "/distributor"}
            icon={
              <HiOutlineTruck className="rs-sidenav-item-icon rs-icon  mb-1" />
            }
            onClick={() => nav("/distributor")}
          >
            Distributor
          </Nav.Item> */}
          <Nav.Item
            eventKey="user"
            active={activeKey === "/user"}
            icon={<FiUser className="rs-sidenav-item-icon rs-icon  mb-1" />}
            onClick={() => nav("/user")}
          >
            User
          </Nav.Item>
          <Nav.Menu
            eventKey="inventory"
            title="Inventory"
            icon={
              countProduct > 0 ? (
                <div className="bubble h-5 aspect-square absolute top-4 left-5 p-0.5">
                  <div className="relative">
                    <MdOutlineInventory className="rs-sidenav-item-icon rs-icon" />
                    <div className="aspect-square rounded-full bg-red-600 absolute -bottom-1 -right-1 text-white text-[6pt] p-0.5 h-3.5 text-center ">
                      {countProduct < 100 ? countProduct : "99+"}
                    </div>
                  </div>
                </div>
              ) : (
                <MdOutlineInventory className="rs-sidenav-item-icon rs-icon" />
              )
            }
          >
            <Nav.Item
              eventKey="brand"
              active={activeKey === "/brand"}
              icon={
                <TiTags className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/brand")}
            >
              Brand
            </Nav.Item>
            <Nav.Item
              eventKey="top-brand"
              active={activeKey === "/top-brand"}
              icon={
                <TbTagStarred className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/top-brand")}
            >
              Top Brand
            </Nav.Item>
            <Nav.Item
              eventKey="popular-product"
              active={activeKey === "/popular-product"}
              icon={
                <BsStar className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/popular-product")}
            >
              Popular Product
            </Nav.Item>
            {/* <Nav.Item
              eventKey="master-product"
              active={activeKey === "/master-product"}
              icon={
                <AiOutlineShoppingCart className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/master-product")}
            >
              Master Product
            </Nav.Item> */}
            <Nav.Item
              eventKey="product"
              active={activeKey === "/product"}
              icon={
                <HiOutlineShoppingBag className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/product")}
            >
              Product
            </Nav.Item>
            <Nav.Item
              eventKey="product-pending"
              active={activeKey === "/product-pending"}
              icon={
                countProduct > 0 ? (
                  <div className="h-5 aspect-square float-left p-0.5 text-xs  mr-[5px] bg-red-500 text-white text-center rounded-full">
                    {countProduct < 100 ? countProduct : "99+"}
                  </div>
                ) : (
                  <TbShoppingBagExclamation className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
                )
              }
              onClick={() => nav("/product-pending")}
            >
              Product Pending
            </Nav.Item>
            <Nav.Item
              eventKey="product-recommendation"
              active={activeKey === "/product-recommendation"}
              icon={
                <GrLike className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/product-recommendation")}
            >
              Recommendation
            </Nav.Item>
            <Nav.Item
              eventKey="product-category"
              active={activeKey === "/product-category"}
              icon={
                <TbCategory2 className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/product-category")}
            >
              Product Category
            </Nav.Item>
            <Nav.Item
              eventKey="tag"
              active={activeKey === "/tag"}
              icon={
                <TiTags className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/tag")}
            >
              Tag
            </Nav.Item>
            <Nav.Item
              eventKey="product-attribute"
              active={activeKey === "/product-attribute"}
              icon={
                <TbCodeAsterisk className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/product-attribute")}
            >
              Product Attribute
            </Nav.Item>
            {/* <Nav.Item
              eventKey="price-category"
              active={activeKey === "/price-category"}
              icon={
                <AiOutlineDollar className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/price-category")}
            >
              Price Category
            </Nav.Item> */}
            <Nav.Item
              eventKey="warehouse"
              active={activeKey === "/warehouse"}
              icon={
                <PiWarehouse className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/warehouse")}
            >
              Warehouse
            </Nav.Item>
            <Nav.Item
              eventKey="stock-movement"
              active={activeKey === "/stock-movement"}
              icon={
                <TfiReload className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/stock-movement")}
            >
              Stock Movement
            </Nav.Item>
          </Nav.Menu>
          <Nav.Menu
            eventKey="order"
            title="Order"
            icon={
              countMerchant + countSales > 0 ? (
                <div className="bubble h-5 aspect-square absolute top-4 left-5 p-0.5">
                  <div className="relative">
                    <GrMoney className="rs-sidenav-item-icon rs-icon" />
                    <div className="aspect-square rounded-full bg-red-600 absolute -bottom-1 -right-1 text-white text-[6pt] p-0.5 h-3.5 text-center ">
                      {countMerchant + countSales < 100
                        ? countMerchant + countSales
                        : "99+"}
                    </div>
                  </div>
                </div>
              ) : (
                <GrMoney className="rs-sidenav-item-icon rs-icon" />
              )
            }
          >
            <Nav.Item
              eventKey="merchant"
              active={activeKey === "/merchant"}
              icon={
                countMerchant > 0 ? (
                  <div className="h-5 aspect-square float-left p-0.5 text-xs  mr-[5px] bg-red-500 text-white text-center rounded-full">
                    {countMerchant < 100 ? countMerchant : "99+"}
                  </div>
                ) : (
                  <BsShop className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
                )
              }
              onClick={() => nav("/merchant")}
            >
              Merchant
            </Nav.Item>
            <Nav.Item
              eventKey="banner"
              active={activeKey === "/banner"}
              icon={
                <IoTvOutline className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/banner")}
            >
              Banner
            </Nav.Item>
            <Nav.Item
              eventKey="promotion"
              active={activeKey === "/promotion"}
              icon={
                <GiProgression className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/promotion")}
            >
              Promotion
            </Nav.Item>

            <Nav.Item
              eventKey="sales"
              active={activeKey === "/sales"}
              icon={
                countSales > 0 ? (
                  <div className="h-5 aspect-square float-left p-0.5 text-xs  mr-[5px] bg-red-500 text-white text-center rounded-full">
                    {countSales < 100 ? countSales : "99+"}
                  </div>
                ) : (
                  <PiCashRegisterLight className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
                )
              }
              onClick={() => nav("/sales")}
            >
              Sales
            </Nav.Item>

            <Nav.Item
              eventKey="withdrawal"
              active={activeKey === "/withdrawal"}
              icon={
                countWitdrawal > 0 ? (
                  <div className="h-5 aspect-square float-left p-0.5 text-xs  mr-[5px] bg-red-500 text-white text-center rounded-full">
                    {countWitdrawal < 100 ? countWitdrawal : "99+"}
                  </div>
                ) : (
                  <TbMoneybag className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
                )
              }
              onClick={() => nav("/withdrawal")}
            >
              Withdrawal
            </Nav.Item>
          </Nav.Menu>
          <Nav.Menu
            eventKey="system"
            title="System"
            icon={<BsGear className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />}
          >
            <Nav.Item
              eventKey="admin"
              active={activeKey === "/admin"}
              icon={
                <GoPeople className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/admin")}
            >
              Admin
            </Nav.Item>
            <Nav.Item
              eventKey="role"
              active={activeKey === "/role"}
              icon={
                <LuFolderKey className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/role")}
            >
              Role
            </Nav.Item>
            <Nav.Item
              eventKey="merchant-type"
              active={activeKey === "/merchant-type"}
              icon={
                <IoStorefrontOutline className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/merchant-type")}
            >
              Merchant Type
            </Nav.Item>
            <Nav.Item
              eventKey="setting"
              active={activeKey === "/setting"}
              icon={
                <BsGear className="rs-sidenav-item-icon rs-icon mr-2 mb-1" />
              }
              onClick={() => nav("/setting")}
            >
              Setting
            </Nav.Item>
          </Nav.Menu>
        </Nav>
      </Sidenav.Body>
    </Sidenav>
  );
};
export default CustomSidebar;
